var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q } from "@http";
import { observable, action, runInAction } from "mobx";
import Cookies from "js-cookie";
import { toCamelCaseData, setLocationId, getLocationId, getClientCode, } from "@common/utils/index";
import { Localstorage } from "@common/utils/storage";
import { getUrlParams } from "@common/utils/url";
import { residentScheduleOptimizationList } from "@router/layout/config";
var CommonStore = /** @class */ (function () {
    function CommonStore() {
        var _this = this;
        this.menuShow = false;
        this.currentUser = {};
        this.title = "";
        this.isHideHeader = false;
        this.isShowCopilot = false;
        this.isRedirectRequestRepairToCopilot = false;
        this.isShowBack = false;
        this.isShowEmergencyMessage = false;
        this.emergencyMessageHeight = 0;
        this.isHideToggler = false;
        this.clientCode = getClientCode(Cookies.get("clientCode"));
        this.clientId = Cookies.get("clientId");
        this.callCenter = "";
        this.isABServiceRequest = false;
        this.ratingABModule = false;
        this.location = {};
        this.customConfigs = [];
        this.weather = [];
        this.isTermAccepted = true;
        this.isTermCheckShow = false;
        this.textMessageStatus = {
            IsReceiveSMSAlert: true,
        };
        this.logoClickLog = function () { return __awaiter(_this, void 0, void 0, function () {
            var isHomePage;
            return __generator(this, function (_a) {
                isHomePage = /#\/$/.test(location.href);
                if (isHomePage) {
                    // if location is homepage, click the logo need to refresh page
                    location.reload();
                }
                return [2 /*return*/];
            });
        }); };
        this.weatherForecast = [];
        this.emergencyMessage = null;
        this.isResidentRatingToggle = false;
        this.isShowAppPromotion = false;
        this.intentResult = null;
        this.isEnableCopilotFeatureToggleSwitcher = null;
    }
    CommonStore.prototype.setTitle = function (title) {
        this.title = title;
    };
    CommonStore.prototype.hideHeader = function (hideHeader) {
        this.isHideHeader = hideHeader;
    };
    CommonStore.prototype.showBack = function (showBack) {
        this.isShowBack = showBack;
    };
    CommonStore.prototype.showEmergencyMessage = function (f) {
        this.isShowEmergencyMessage = f;
        if (!f)
            Localstorage.write("isAlertedNCOV", true);
    };
    CommonStore.prototype.setEmergencyMessageHeight = function (n) {
        this.emergencyMessageHeight = n;
    };
    CommonStore.prototype.hideToggler = function (isHideToggler) {
        this.isHideToggler = isHideToggler;
    };
    CommonStore.prototype.toggleMenu = function () {
        this.menuShow = !this.menuShow;
    };
    CommonStore.prototype.isResidentScheduleOptimizationEmail = function () {
        return residentScheduleOptimizationList.some(function (x) {
            return location.href.toLowerCase().includes(x.path.toLowerCase());
        });
    };
    CommonStore.prototype.getToken = function () {
        var _a, _b;
        var token = (_b = (_a = getUrlParams()) === null || _a === void 0 ? void 0 : _a.token) === null || _b === void 0 ? void 0 : _b.split("?")[0];
        if (!token) {
            return console.error("not token.");
        }
        return token;
    };
    CommonStore.prototype.getClientCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cookieClientCode, code;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cookieClientCode = Cookies.get("clientCode");
                        if (cookieClientCode) {
                            runInAction(function () {
                                _this.clientCode = getClientCode(cookieClientCode);
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.api().getClientCode(this.getToken())];
                    case 1:
                        code = _a.sent();
                        runInAction(function () {
                            _this.clientCode = getClientCode(code);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.getClientInfoByDomain = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clientInfo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getClientInfo()];
                    case 1:
                        clientInfo = _a.sent();
                        runInAction(function () {
                            _this.clientCode = clientInfo.clientCode;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.getCallCenter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCallCenter()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.callCenter = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.getABServiceRequest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().isABServiceRequest()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isABServiceRequest = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.getRatingABModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getRatingABModule()];
                    case 1:
                        promise = _a.sent();
                        return [4 /*yield*/, promise];
                    case 2:
                        data = _a.sent();
                        runInAction(function () {
                            _this.ratingABModule = data === true || data === "true" || data === "True";
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    CommonStore.prototype.getLocationResidential = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getLocationResidential();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            data && setLocationId(data.locationId || data.LocationId);
                            _this.location = data || {};
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    CommonStore.prototype.getCustomConfigs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Cookies.get("clientId") ||
                            this.isResidentScheduleOptimizationEmail()) {
                            this.customConfigs = null;
                            return [2 /*return*/, null];
                        }
                        promise = this.api().getCustomConfigs();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.customConfigs = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    CommonStore.prototype.getNext7DaysWeather = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getNext7DaysWeather(getLocationId())];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.weather = data || [];
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.setIsTermAccepted = function (flag) {
        var _this = this;
        runInAction(function () {
            _this.isTermAccepted = flag;
        });
    };
    CommonStore.prototype.getUserTermsAcceptedStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getUserTermsAcceptedStatus()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isTermAccepted = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    // 这里需要暴露强制修改 term show 接口，因为当没有phone 确认之后必须关闭此窗口，但不修改后台数据
    CommonStore.prototype.setTermCheckShow = function (flag) {
        var _this = this;
        runInAction(function () {
            _this.isTermCheckShow = flag;
        });
    };
    CommonStore.prototype.getTextMessageStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getTextMessageStatus();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.textMessageStatus = data || _this.textMessageStatus;
                            // 获得isTermAccepted 和 IsReceiveSMSAlert 之后判断是否该显示term check
                            // change logic by SQ-233
                            _this.isTermCheckShow = !_this.textMessageStatus.IsReceiveSMSAlert;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    CommonStore.prototype.receiveSMSAlert = function (isUserTermsAccepted) {
        return this.api().receiveSMSAlert({
            isReceiveUpdates: isUserTermsAccepted,
            phone: this.textMessageStatus.CellPhone,
        });
    };
    CommonStore.prototype.updateSMSAlert = function (isCallPhone) {
        var _this = this;
        runInAction(function () {
            _this.textMessageStatus.IsReceiveSMSAlert = isCallPhone;
        });
        return this.api().updateSMSAlert({
            residentId: this.textMessageStatus.Id,
            isReceiveSMSAlert: isCallPhone,
            mobile: this.textMessageStatus.CellPhone,
        });
    };
    CommonStore.prototype.getCurrentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCurrentUser(this.getToken())];
                    case 1:
                        user = _a.sent();
                        runInAction(function () {
                            Cookies.set("userId", user.UserId);
                            Cookies.set("userName", user.UserName);
                            Cookies.set("residentId", user === null || user === void 0 ? void 0 : user.ResidentId);
                            _this.currentUser = toCamelCaseData(user);
                        });
                        return [2 /*return*/, user];
                }
            });
        });
    };
    CommonStore.prototype.getWeatherForecastByTime = function (dates) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getWeatherForecastByTime(dates)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.weatherForecast = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.getEmergencyMessage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var msg;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getEmergencyMessage()];
                    case 1:
                        msg = _a.sent();
                        runInAction(function () {
                            _this.emergencyMessage = msg;
                            var isAlertedNCOV = Localstorage.read("isAlertedNCOV");
                            if (msg !== null && !isAlertedNCOV) {
                                _this.isShowEmergencyMessage = true;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.getRatingToggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getRatingToggle();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            var tempData = typeof data === "string" ? false : data;
                            _this.isResidentRatingToggle = tempData;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    CommonStore.prototype.getAppPromotionFeatureToggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bannerVisible, isUserClosedBanner, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api().checkBannerVisible()];
                    case 1:
                        bannerVisible = _b.sent();
                        _a = bannerVisible;
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.api().isUserClosedBanner()];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        isUserClosedBanner = _a;
                        runInAction(function () {
                            _this.isShowAppPromotion = bannerVisible && !isUserClosedBanner;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.closeAppPromotion = function () {
        this.api().closeBanner();
        this.isShowAppPromotion = false;
    };
    CommonStore.prototype.getCopilotEnable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCopilotEnable()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isShowCopilot = data;
                            _this.isRedirectRequestRepairToCopilot = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.matchIntent = function (intent) {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().matchIntent(intent)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.intentResult = data;
                        });
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CommonStore.prototype.getEnableCopilotFeatureToggleSwitcher = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().isEnableCopilotFeatureToggleSwitcher()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isEnableCopilotFeatureToggleSwitcher = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonStore.prototype.getCopilotConversationStatus = function (conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCopilotConversationStatus(conversationId)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CommonStore.prototype.sendVerificationCode = function (phoneNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().sendVerificationCode(phoneNumber)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CommonStore.prototype.verifyCode = function (phoneNumber, code) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().verifyCode(phoneNumber, code)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CommonStore.prototype.updateAccountPhone = function (accountPhone) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().updateAccountPhone(accountPhone)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CommonStore.prototype.updateAccountName = function (accountName) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().updateAccountName(accountName)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CommonStore.prototype.getConfirmedPhone = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getConfirmedPhone()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CommonStore.prototype.api = function () {
        var _this = this;
        return {
            getCustomConfigs: function () {
                return Q(http.get("/RSP/Dashboard/GetCustomConfigByClientId?clientId=" + Cookies.get("clientId")));
            },
            getCallCenter: function () {
                return Q(http.get("RSP/Dashboard/GetCallCenter"));
            },
            isABServiceRequest: function () {
                return Q(http.get("RSP/Dashboard/IsABServiceRequest"));
            },
            getRatingABModule: function () {
                return Q(http.get("RSP/Dashboard/RatingABModule"));
            },
            getLocationResidential: function () {
                return Q(http.get("RSP/Dashboard/GetLocationResidential"));
            },
            getNext7DaysWeather: function (locationId) {
                return Q(http.get("RSP/Dashboard/GetNext7DaysWeather?locationId=" + locationId));
            },
            getUserTermsAcceptedStatus: function () {
                return Q(http.get("RSP/Dashboard/GetUserTermsAcceptedStatus"));
            },
            getTextMessageStatus: function () {
                return Q(http.get("RSP/Dashboard/GetTextMessageStatus"));
            },
            receiveSMSAlert: function (acceptTermParmas) {
                return Q(http.post("RSP/Dashboard/AcceptTerms", acceptTermParmas));
            },
            updateSMSAlert: function (updateSMSAlertParmas) {
                return Q(http.post("RSP/Dashboard/UpdateSMSAlert", updateSMSAlertParmas));
            },
            getCurrentUser: function (token) {
                if (_this.isResidentScheduleOptimizationEmail())
                    return Q(http.get("/ResidentScheduleOptimization/getcurrentuser?token=" + token));
                return Q(http.get("/rsp/dashboard/getcurrentuser"));
            },
            getEmergencyMessage: function () {
                return Q(http.get("/EmergencyMessage/GetEmergencyMessage"));
            },
            getWeatherForecastByTime: function (dates) {
                return Q(http.get("RSP/NewRequest/GetWeatherForecastByTime"));
            },
            getClientCode: function (token) {
                if (_this.isResidentScheduleOptimizationEmail())
                    return Q(http.get("/ResidentScheduleOptimization/GetClientCode?token=" + token));
                return Q(http.get("/DRSP/Dashboard/GetClientCode"));
            },
            getClientInfo: function () {
                return Q(http.get("DRSP/Account/GetClientInfoByDomain"));
            },
            getRatingToggle: function () {
                return Q(http.get("/RSP/Request/IsResidentRating"));
            },
            getAppPromotionFeatureToggle: function () {
                return Q(http.get("/RSP/Request/IsResidentRating"));
            },
            checkBannerVisible: function () {
                return Q(http.get("/dashboard/CheckBannerVisible"));
            },
            isUserClosedBanner: function () {
                return Q(http.get("/dashboard/IsUserClosedBanner"));
            },
            closeBanner: function () {
                return Q(http.post("/dashboard/CloseBanner"));
            },
            getCopilotEnable: function () {
                return Q(http.get("/Copilot/IsEnable"));
            },
            getCopilotConversationStatus: function (conversationId) {
                return Q(http.get("/copilot/conversation/status/" + conversationId));
            },
            isEnableCopilotFeatureToggleSwitcher: function () {
                return Q(http.get("/Copilot/IsEnableCopilotFeatureToggleSwitcher?featureToggleId=3585"));
            },
            matchIntent: function (intent) {
                return Q(http.post("/copilot/conversation/match-intent", intent));
            },
            sendVerificationCode: function (phone) {
                return Q(http.post("/LocationResident/verification-code", { phone: phone }));
            },
            verifyCode: function (phone, verificationCode) {
                return Q(http.post("/LocationResident/verification-code/verify", { phone: phone, verificationCode: verificationCode }));
            },
            updateAccountPhone: function (accountPhone) {
                return Q(http.post("/LocationResident/profile/cellphone", accountPhone));
            },
            updateAccountName: function (accountName) {
                return Q(http.post("/LocationResident/profile/complete", accountName));
            },
            getConfirmedPhone: function () {
                return Q(http.get("/LocationResident/profile/phone/confirmed"));
            }
        };
    };
    __decorate([
        observable
    ], CommonStore.prototype, "menuShow", void 0);
    __decorate([
        observable
    ], CommonStore.prototype, "currentUser", void 0);
    __decorate([
        observable
    ], CommonStore.prototype, "title", void 0);
    __decorate([
        action.bound
    ], CommonStore.prototype, "setTitle", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isHideHeader", void 0);
    __decorate([
        observable
    ], CommonStore.prototype, "isShowCopilot", void 0);
    __decorate([
        observable
    ], CommonStore.prototype, "isRedirectRequestRepairToCopilot", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "hideHeader", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isShowBack", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "showBack", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isShowEmergencyMessage", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "showEmergencyMessage", null);
    __decorate([
        observable
    ], CommonStore.prototype, "emergencyMessageHeight", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "setEmergencyMessageHeight", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isHideToggler", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "hideToggler", null);
    __decorate([
        action
    ], CommonStore.prototype, "toggleMenu", null);
    __decorate([
        observable
    ], CommonStore.prototype, "clientCode", void 0);
    __decorate([
        observable
    ], CommonStore.prototype, "clientId", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "isResidentScheduleOptimizationEmail", null);
    __decorate([
        action
    ], CommonStore.prototype, "getToken", null);
    __decorate([
        action.bound
    ], CommonStore.prototype, "getClientCode", null);
    __decorate([
        action.bound
    ], CommonStore.prototype, "getClientInfoByDomain", null);
    __decorate([
        observable
    ], CommonStore.prototype, "callCenter", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getCallCenter", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isABServiceRequest", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getABServiceRequest", null);
    __decorate([
        observable
    ], CommonStore.prototype, "ratingABModule", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getRatingABModule", null);
    __decorate([
        observable
    ], CommonStore.prototype, "location", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getLocationResidential", null);
    __decorate([
        observable
    ], CommonStore.prototype, "customConfigs", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getCustomConfigs", null);
    __decorate([
        observable
    ], CommonStore.prototype, "weather", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getNext7DaysWeather", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isTermAccepted", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "setIsTermAccepted", null);
    __decorate([
        action
    ], CommonStore.prototype, "getUserTermsAcceptedStatus", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isTermCheckShow", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "setTermCheckShow", null);
    __decorate([
        observable
    ], CommonStore.prototype, "textMessageStatus", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getTextMessageStatus", null);
    __decorate([
        action.bound
    ], CommonStore.prototype, "logoClickLog", void 0);
    __decorate([
        action.bound
    ], CommonStore.prototype, "getCurrentUser", null);
    __decorate([
        observable
    ], CommonStore.prototype, "weatherForecast", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getWeatherForecastByTime", null);
    __decorate([
        observable
    ], CommonStore.prototype, "emergencyMessage", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getEmergencyMessage", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isResidentRatingToggle", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getRatingToggle", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isShowAppPromotion", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getAppPromotionFeatureToggle", null);
    __decorate([
        action.bound
    ], CommonStore.prototype, "closeAppPromotion", null);
    __decorate([
        action.bound
    ], CommonStore.prototype, "getCopilotEnable", null);
    __decorate([
        observable
    ], CommonStore.prototype, "intentResult", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "matchIntent", null);
    __decorate([
        observable
    ], CommonStore.prototype, "isEnableCopilotFeatureToggleSwitcher", void 0);
    __decorate([
        action
    ], CommonStore.prototype, "getEnableCopilotFeatureToggleSwitcher", null);
    __decorate([
        action
    ], CommonStore.prototype, "getCopilotConversationStatus", null);
    __decorate([
        action
    ], CommonStore.prototype, "sendVerificationCode", null);
    __decorate([
        action
    ], CommonStore.prototype, "verifyCode", null);
    __decorate([
        action
    ], CommonStore.prototype, "updateAccountPhone", null);
    __decorate([
        action
    ], CommonStore.prototype, "updateAccountName", null);
    __decorate([
        action
    ], CommonStore.prototype, "getConfirmedPhone", null);
    return CommonStore;
}());
export default CommonStore;
